//  @flow
import ReviewPage from './ReviewPage';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { isValid } from 'redux-form';
import type { State } from 'types/redux';
import type { Props } from './ReviewPage';
import { injectIntl } from 'react-intl';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import {
  bookAppt,
  cancelAppt,
  sendScheduleServiceReviewShown,
  sendScheduleServiceReviewStart,
  sendCustomerInfoFormShown
} from 'store/reducers/appointment/actions';
import { gtmUserEvent, gtmRecaptchaEvent } from 'store/reducers/gtm/actions';
import { setActivePromotion } from 'store/reducers/promotions/actions';
import {
  mobilePhoneNumberPopulated,
  setRecaptchaToken
} from 'store/reducers/userInteractions/actions';

// Selectors
import {
  getVehicle,
  getServices,
  getDeclinedServices,
  getServicePoint,
  getAdvisorId,
  getParticipantComments,
  getPrivacySettings,
  getTransportationOption,
  getAppointment,
  getTotalPrice,
  isApptInPromoInterval,
  getServicesCount,
  isPromotionInRange,
  isCarryOver,
  isDmsAppt,
  isQuoteAppt
} from 'store/reducers/appointment/selectors';
import {
  getAdvisors,
  getTransportOptions
} from 'store/reducers/apptOptions/selectors';
import {
  getPriceVisibility,
  isLicenseNumberValid,
  getShowMileage,
  getFlexPayConfiguration,
  getExternalValetProvider,
  getDealerContact,
  isRecaptchaEnabledOnCancelAppt,
  getRecaptchaToken,
  getSmsSingleOptIn
} from 'store/reducers/dealerSettings/selectors';
import {
  isModifyEnabled,
  getContactInfoMissing,
  isContactInfoFormValid,
  getAppFlow
} from 'store/reducers/userInteractions/selectors';
import { isPromotionEnabled } from 'store/reducers/marketing/selectors';
import { getPromotionDescription } from 'store/reducers/promotions/selectors';
import {
  getCTABanner,
  getBackButton
} from 'store/reducers/optimizelyABTest/selectors';
import { isLoggedIn } from 'store/reducers/user/selectors';
import {
  getPickupAddress,
  getDropoffAddress,
  getIsClutchPartialValet
} from 'store/reducers/appointment/valetDetails/selectors';
import { getLanguageCode } from 'store/reducers/dealerLocale/selectors';

// Utils
import { undefinedToTrue } from 'utils/varValidation';

const mapStateToProps = (state: State): $Shape<Props> => ({
  appointment: state.appointment,
  notes: getParticipantComments(state),
  services: getServices(state),
  declinedServices: getDeclinedServices(state),
  servicePoint: getServicePoint(state),
  servicesCount: getServicesCount(state),
  isContactInfoFormValid: isContactInfoFormValid(state),
  isFormRemindersValid: isValid('RemindersForm')(state),
  isLicenseNumberValid: isLicenseNumberValid(state),
  vehicle: getVehicle(state),
  selectedAdvisorId: getAdvisorId(state),
  totalPrice: getTotalPrice(state),
  advisors: getAdvisors(state),
  promoDescription: getPromotionDescription(state),
  privacySettings: getPrivacySettings(state),
  transportationOption: getTransportationOption(state),
  externalValet: getExternalValetProvider(state),
  transportations: getTransportOptions(state),
  appointmentDate: getAppointment(state),
  isModifyEnabled: isModifyEnabled(state),
  isPromotionEnabled: isPromotionEnabled(state),
  isApptInPromoInterval: isApptInPromoInterval(state),
  priceVisibility: getPriceVisibility(state)(),
  contactInfoMissing: getContactInfoMissing(state),
  showMileage: undefinedToTrue(getShowMileage(state)),
  isPromotionInRange: isPromotionInRange(state),
  isFlexPayEnabled: getFlexPayConfiguration(state),
  appFlow: getAppFlow(state),
  ctaBanner: getCTABanner(state),
  ctaBackButton: getBackButton(state),
  isCarryOver: isCarryOver(state),
  isDmsAppt: isDmsAppt(state),
  isQuoteAppt: isQuoteAppt(state),
  isLoggedIn: isLoggedIn(state),
  pickupAddress: getPickupAddress(state),
  dropoffAddress: getDropoffAddress(state),
  dealerContact: getDealerContact(state),
  isClutchPartialValet: getIsClutchPartialValet(state),
  isRecaptchaEnabledOnCancelAppt: isRecaptchaEnabledOnCancelAppt(state),
  languageCode: getLanguageCode(state),
  recaptchaToken: getRecaptchaToken(state),
  smsSingleOptIn: getSmsSingleOptIn(state)
});

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    {
      goTo,
      bookAppt,
      cancelAppt,
      gtmUserEvent,
      setActivePromotion,
      mobilePhoneNumberPopulated,
      setRecaptchaToken,
      gtmRecaptchaEvent,
      sendScheduleServiceReviewShown,
      sendScheduleServiceReviewStart,
      sendCustomerInfoFormShown
    }
  )
)(ReviewPage);



// WEBPACK FOOTER //
// ./src/components/pages/ReviewPage/ReviewContainer.js